import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Trophy, Calendar, BarChart3, Award } from 'lucide-react';

const Season2Page = ({ section = 'schedule' }) => {
  const { language } = useLanguage();

  const sections = {
    schedule: {
      title: language === 'gr' ? 'Πρόγραμμα' : 'Schedule',
      subtitle: language === 'gr' ? 'Πρόγραμμα Αγώνων 2ης Σεζόν' : 'Season 2 Match Schedule',
      icon: Calendar,
    },
    scoreboard: {
      title: language === 'gr' ? 'Βαθμολογία' : 'Standings',
      subtitle: language === 'gr' ? 'Κατάταξη Πρωταθλήματος 2ης Σεζόν' : '2nd Season Championship Standings',
      icon: Trophy,
    },
    results: {
      title: language === 'gr' ? 'Αποτελέσματα' : 'Results',
      subtitle: language === 'gr' ? 'Ολοκληρωμένοι αγώνες και σκορ 2ης Σεζόν' : 'Completed games and scores of Season 2',
      icon: BarChart3,
    },
    rankings: {
      title: language === 'gr' ? 'Κατάταξη Παικτριών' : 'Player Rankings',
      subtitle: language === 'gr' ? 'Οι κορυφαίες της 2ης σεζόν' : 'Top players of Season 2',
      icon: Award,
    },
  };

  const s = sections[section] || sections.schedule;
  const Icon = s.icon;

  return (
    <div className="max-w-7xl mx-auto px-4 py-12" data-testid={`season2-${section}`}>
      <div className="text-center mb-12">
        <h1 className="section-title mb-2">{s.title}</h1>
        <p className="text-slate-600">{s.subtitle}</p>
      </div>

      <div className="bg-slate-50 border-2 border-dashed border-slate-200 rounded-2xl p-12 text-center">
        <Icon size={48} className="mx-auto text-slate-300 mb-4" />
        <h2 className="text-xl font-display font-bold text-slate-400 mb-2">
          {language === 'gr' ? 'Σύντομα κοντά σας!' : 'Coming Soon!'}
        </h2>
        <p className="text-slate-400 max-w-md mx-auto">
          {language === 'gr' 
            ? 'Η 2η Σεζόν δεν έχει ξεκινήσει ακόμα. Μόλις δηλωθούν οι ομάδες, θα ενημερωθεί αυτή η σελίδα.'
            : 'Season 2 has not started yet. Once teams register, this page will be updated.'}
        </p>
      </div>
    </div>
  );
};

export default Season2Page;
